module.exports = __webpack_public_path__ + "img/gallery01.16a309c4.png";